import React from 'react';
import Lottie from 'react-lottie';

import { Container } from './styles';

import devsigner from '~/assets/animations/devsigner.json';

interface ILoading {
  active: boolean;
  text?: string;
}

const Loading: React.FC<ILoading> = ({ active, text }) => {
  return (
    <Container active={active}>
      <div className="anim-lottie">
        <Lottie
          options={{
            animationData: devsigner,
            autoplay: true,
            loop: true,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice',
            },
          }}
          height={250}
          width={250}
        />
      </div>
      {text && <p>{text}</p>}
    </Container>
  );
};

export default Loading;
